// Loại máy / dịch vụ cho thuê theo giờ: mã lưu DB (giống backend src/lib/resourceTypes.js), tên hiển thị, màu thẻ, ảnh.
export const TYPE_INFO = {
  PS5: { name: 'PS5', cls: 'ps5', image: '/visuals/types/ps5.png' },
  Nintendo: { name: 'Nintendo', cls: 'nin', image: '/visuals/types/nintendo.png' },
  'Private Room': { name: 'Room VIP', cls: 'private', image: '/visuals/types/private-room.webp' },
  Billiards: { name: 'Bida', cls: 'billiards', image: '/visuals/types/billiards.webp' },
  Karaoke: { name: 'Karaoke', cls: 'karaoke', image: '/visuals/types/karaoke.webp' },
  'Karaoke Box': { name: 'Karaoke box', cls: 'karaoke-box', image: '/visuals/types/karaoke-box.webp' },
  Cinema: { name: 'Phòng chiếu phim', cls: 'cinema', image: '/visuals/types/cinema.webp' },
  Football: { name: 'Sân bóng đá', cls: 'football', image: '/visuals/types/football.webp' },
  Futsal: { name: 'Sân bóng đá mini', cls: 'futsal', image: '/visuals/types/futsal.webp' },
  Pickleball: { name: 'Pickleball', cls: 'pickleball', image: '/visuals/types/pickleball.webp' },
  Tennis: { name: 'Tennis', cls: 'tennis', image: '/visuals/types/tennis.webp' },
  Badminton: { name: 'Cầu lông', cls: 'badminton', image: '/visuals/types/badminton.webp' },
  Other: { name: 'Khác', cls: 'other', image: null },
};
export const RESOURCE_TYPES = Object.keys(TYPE_INFO);
export const BOOKABLE_TYPES = RESOURCE_TYPES.filter((type) => type !== 'Other');
export const typeName = (type) => TYPE_INFO[type]?.name || type || '—';
export const typeOptions = (types = RESOURCE_TYPES) => types.map((id) => ({ id, name: typeName(id) }));
